import { publicEnv } from "@/src/config/publicEnv";

export const API_CONFIG = {
  baseURL: publicEnv.baseUrl,
  timeoutMs: 30_000,
  authHeaderPrefix: "Bearer",
} as const;
